import {CanMatchFn} from '@angular/router';

export type TranslationsVisualFixtureState =
  | 'pages-default'
  | 'pages-confirmation'
  | 'pages-error'
  | 'jobs'
  | 'jobs-error'
  | 'settings';

const allowedFixtureStates = new Set<TranslationsVisualFixtureState>([
  'pages-default',
  'pages-confirmation',
  'pages-error',
  'jobs',
  'jobs-error',
  'settings',
]);
const allowedFixturePaths = new Set(['/translations']);
const localFixtureHosts = new Set(['localhost', '127.0.0.1', '[::1]', '::1']);

export function readTranslationsVisualFixtureState(href: string): TranslationsVisualFixtureState | null {
  const url = new URL(href);
  const fixtureState = url.searchParams.get('translationsVisualFixture') || '';

  if (
    !localFixtureHosts.has(url.hostname) ||
    !allowedFixturePaths.has(url.pathname) ||
    !allowedFixtureStates.has(fixtureState as TranslationsVisualFixtureState)
  ) {
    return null;
  }

  return fixtureState as TranslationsVisualFixtureState;
}

export function isTranslationsVisualFixtureUrl(href: string): boolean {
  return readTranslationsVisualFixtureState(href) !== null;
}

export const translationsVisualFixtureCanMatch: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location) return false;

  return isTranslationsVisualFixtureUrl(window.location.href);
};
